import React, { PureComponent } from 'react';

import {
    CRow,
    CCol,
    CButton,
    CTooltip
} from '@coreui/react';

import CIcon from '@coreui/icons-react';

import { helps } from 'src/_helpers';

import { ThePermission }
from 'src/containers/ThePermission';

import { ChecksFormContainer }
from 'src/containers/checks';

class CheckHistoryRow extends PureComponent {

    getDefaultShift() {

        const {
            employeeData
        } = this.props;

        const position =
            employeeData?.position;

        if (
            !position ||
            !position.shifts
        ) {
            return {};
        }

        return (
            position.shifts.find(
                shift =>
                    shift.id ===
                    employeeData.shift_id
            ) || {}
        );
    }

    renderCheckoutButton() {

        const {
            check,
            employeeData,
            employee,
            project,
            curent_date,
            show_forms,
            toggleForm
        } = this.props;

        if (
            check.checked_out > 0
        ) {
            return null;
        }

        const targetEmployee =
            employee ||
            employeeData?.employee;

        if (!targetEmployee) {
            return null;
        }

        const position =
            employeeData?.position ||
            check.position;

        const defaultShift =
            this.getDefaultShift();

        const formId =
            targetEmployee.employee_id +
            '-false';

        return (

            <ThePermission
                {...this.props}
                component="projects"
                action="edit"
            >

                <CTooltip
                    content={
                        'Check-out: ' +
                        targetEmployee.fullname
                    }
                >

                    <CButton
                        color="danger"
                        size="sm"
                        onClick={() =>
                            toggleForm(formId)
                        }
                    >

                        <CIcon
                            name="cil-x-circle"
                        />

                        {' '}

                        Check-out

                    </CButton>

                </CTooltip>

                <ChecksFormContainer

                    key={
                        'checkout-' +
                        targetEmployee.employee_id +
                        '-' +
                        check.id
                    }

                    {...this.props}

                    action="checkout"

                    is_overtime={false}

                    curent_date={
                        curent_date
                    }

                    default_shift={
                        defaultShift
                    }

                    default_position={
                        position
                    }

                    employee={
                        targetEmployee
                    }

                    position={
                        position
                    }

                    project={
                        project
                    }

                    check={
                        check
                    }

                    show_forms={
                        show_forms
                    }

                    toggleForm={
                        toggleForm
                    }

                />

            </ThePermission>

        );
    }

    renderDeleteButton() {

        const {
            check,
            user,
            handleDelete
        } = this.props;

        const isAuthor =
            check.added_by ===
            user.id;

        return (

            <CButton

                color={
                    isAuthor
                        ? 'danger'
                        : 'secondary'
                }

                size="sm"

                disabled={
                    !isAuthor
                }

                title={
                    `Xoá: ${check.id} | bởi: ${check.added_by_alias}`
                }

                onClick={e =>
                    handleDelete(
                        e,
                        check
                    )
                }
            >

                <CIcon
                    name="cil-trash"
                />

            </CButton>

        );
    }

    render() {

        const {
            check
        } = this.props;

        return (

            <CRow
                key={check.id}
                id={check.id}
                className="mb-2"
            >

                {/* CHECK-IN */}

                <CCol md={4}>

                    {
                        check.checked_in > 0 &&
                        (

                            <div>

                                <span
                                    className="
                                        text-muted
                                        font-italic
                                    "
                                >
                                    Check-in lúc:
                                </span>

                                {' '}

                                <b>

                                    {
                                        helps.formatDateTime_from_Timestamp(
                                            check.checkin_time
                                        )
                                    }

                                </b>

                                <div>

                                    (
                                    <span
                                        className="
                                            text-muted
                                            font-italic
                                        "
                                    >
                                        Checkin tại:
                                    </span>

                                    {' '}

                                    <b>
                                        {
                                            check.position?.name
                                        }
                                    </b>

                                    )

                                </div>

                                {
                                    check.note &&
                                    (

                                        <div>

                                            <span
                                                className="
                                                    text-muted
                                                    font-italic
                                                "
                                            >
                                                <u>
                                                    Ghi chú:
                                                </u>
                                            </span>

                                            {' '}

                                            {
                                                check.note
                                            }

                                        </div>

                                    )
                                }

                            </div>

                        )
                    }

                </CCol>

                {/* CHECK-OUT */}

                <CCol md={4}>

                    {
                        check.checked_out > 0 &&
                        (

                            <div>

                                <span
                                    className="
                                        text-muted
                                        font-italic
                                    "
                                >
                                    Check-out lúc:
                                </span>

                                {' '}

                                <b>

                                    {
                                        helps.formatDateTime_from_Timestamp(
                                            check.checkout_time
                                        )
                                    }

                                </b>

                                <div>

                                    (
                                    <span
                                        className="
                                            text-muted
                                            font-italic
                                        "
                                    >
                                        Checkout tại:
                                    </span>

                                    {' '}

                                    <b>
                                        {
                                            check.position?.name
                                        }
                                    </b>

                                    )

                                </div>

                                {
                                    check.note &&
                                    (

                                        <div>

                                            <span
                                                className="
                                                    text-muted
                                                    font-italic
                                                "
                                            >
                                                <u>
                                                    Ghi chú:
                                                </u>
                                            </span>

                                            {' '}

                                            {
                                                check.note
                                            }

                                        </div>

                                    )
                                }

                            </div>

                        )
                    }

                    {
                        this.renderCheckoutButton()
                    }

                </CCol>

                {/* DURATION */}

                <CCol md={3}>

                    <div>

                        Giờ công:

                        {' '}

                        <b>

                            {
                                parseFloat(
                                    (
                                        check.check_duration || 0
                                    ) / 60
                                ).toFixed(2)
                            }

                        </b>

                        {
                            check.is_overtime &&
                            (
                                <i>
                                    {' '}
                                    (tăng ca)
                                </i>
                            )
                        }

                        <div
                            className="
                                text-muted
                            "
                        >

                            ID:

                            {' '}

                            <small>
                                {
                                    check.id
                                }
                            </small>

                        </div>

                    </div>

                </CCol>

                {/* DELETE */}

                <CCol md={1}>

                    {
                        this.renderDeleteButton()
                    }

                </CCol>

            </CRow>

        );
    }
}

export default CheckHistoryRow;